import './OrganizationsList.scss';
import '../../Admin.scss';
import '../../../../styles/_table.scss';
import { Link, useNavigate } from 'react-router-dom';
import { Table, TableHead, TableRow, TableCell, TableBody, LoadingPlaceholder } from '@trackman/web-shared-components';
import HeaderCreateButton from 'components/Admin/HeaderCreateButton/HeaderCreateButton';
import HeaderSearchbar from 'components/Admin/HeaderSearchbar/HeaderSearchbar';
import { AdminPagesRelativeRoutes, DefaultRoutes } from 'Routes';
import useSetPageTitle from 'utilities/useSetPageTitle';
import { useState } from 'react';
import { AdminOrganizationsList } from 'types/admin/organizations';
import { useGetAdminOrganizationsList } from 'queryHooks/Admin/Organization/useGetAdminOrganizationsList';
import { NoEntriesMatching } from 'components/NoEntriesMatching/NoEntriesMatching';
import { CreateEntryCard } from 'components/Admin/CreateEntryCard/CreateEntryCard';

export const OrganizationsList = () => {
  useSetPageTitle({ title: 'Organizations List' });
  const navigate = useNavigate();

  const [filter, setFilter] = useState<string>('');
  const { data, isPending } = useGetAdminOrganizationsList();
  const filteredOrganizations: AdminOrganizationsList | undefined = !filter
    ? data
    : data?.filter((organization) => organization.name.toLowerCase().includes(filter.toLowerCase()));

  return (
    <>
      <div className='default-page-header'>
        <h1 className='page-title'>Organizations List</h1>
      </div>
      <div className='admin-content-container'>
        {!isPending ? (
          <>
            <div className='admin-list-header'>
              <HeaderSearchbar searchValue={filter} onChange={(filter) => setFilter(filter)} placeholder='Search Organizations' />
              <HeaderCreateButton
                buttonTitle='New Organization'
                onClick={() => navigate(`${DefaultRoutes.Admin}/${AdminPagesRelativeRoutes.OrganizationsEditor}`)}
              />
            </div>
            {!filteredOrganizations ? (
              <CreateEntryCard
                entity='Organization'
                intent='secondary'
                onClick={() => navigate(`${DefaultRoutes.Admin}/${AdminPagesRelativeRoutes.OrganizationsEditor}`)}
              />
            ) : filteredOrganizations && filteredOrganizations.length > 0 ? (
              <div className='tmu-table-wrapper'>
                <Table className='tmu-table admin-table'>
                  <TableHead>
                    <TableRow>
                      <TableCell>Name</TableCell>
                      <TableCell></TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {filteredOrganizations.map((row, index) => {
                      return <OrganizationsListRow key={index} id={row.id} name={row.name} disabled={row.disabled ?? false} />;
                    })}
                  </TableBody>
                </Table>
              </div>
            ) : (
              <NoEntriesMatching />
            )}
          </>
        ) : (
          <LoadingPlaceholder />
        )}
      </div>
    </>
  );
};

type OrganizationsListRowProps = {
  id: string;
  name: string;
  disabled: boolean;
};
const OrganizationsListRow = ({ id, name, disabled }: OrganizationsListRowProps) => {
  return (
    <TableRow hover tabIndex={-1} key={id} className='organization-list-row'>
      <TableCell>
        <Link to={`${DefaultRoutes.Admin}/${AdminPagesRelativeRoutes.OrganizationsEditor}/${id}`}>
          <div>{name}</div>
        </Link>
      </TableCell>
      <TableCell>
        <span className={disabled ? 'disabled-info' : ''}>{disabled ? 'Disabled' : 'Active'}</span>
      </TableCell>
    </TableRow>
  );
};
